import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRow } from "@ionic/react";
import { TemplateCreateForm } from "./components/TemplateCreateForm";
import { Toolbar } from "./components/Toolbar";

export const TemplateCreate: React.FC = () => {
  
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <Toolbar />
      </IonHeader>
      <IonContent fullscreen>
        <IonGrid>
          <IonRow>
            <IonCol>
              <TemplateCreateForm />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
